'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionNames = require('../utils/actionNames');

var _is = require('../utils/is');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var uniqEs6 = function uniqEs6(arrArg) {
    return arrArg.filter(function (elem, pos, arr) {
        return arr.indexOf(elem) == pos;
    });
};
/** Class representing base action logic . */

var BaseAction =
/**
 * Create an action.
 * @param {String} type - The action type. Ex: 'create'.
 * @param {Object} config - The configuration for the action.
 */
function BaseAction(type, config) {
    _classCallCheck(this, BaseAction);

    _initialiseProps.call(this);

    var configBase = { type: type };
    this.config = _extends(configBase, config);
    this.actionNames = (0, _actionNames.generateActionNames)(config.actionPrefix, type);
}

/**
 * Base action dispatcher.
 * @param {Function} type - start, success or error.
 * @param {Function} dispatch - The dispatch function provided by Redux.
 * @param {Object} actionData - Data to the original action.
 * @param {Object} responseData - Data from the async request handlers (creator, deleter, updater, fetcher).
 * @param {Object} additionalData - Optional additional data to be saved with the instance
 * @param {Object} updateData - Optional additional data to be saved with the instance
 *
 * @returns {void}
 */


/**
 * Validates instance key, throws an exception if instance key is not valid
 * @param {String} instance - name of the instance
 *
 * @returns {void}
 */


/**
 * Dispatch start and startPost actions.
 * @param {Array} args - All function args to be passed to _dispatch
 *
 * @returns {void}
 */


/**
 * Dispatch success and successPost actions.
 * @param {Array} args - All function args to be passed to _dispatch
 *
 * @returns {void}
 */


/**
 * Dispatch error and errorPpost actions.
 * @param {Array} args - All function args to be passed to _dispatch
 *
 * @returns {void}
 */
;

var _initialiseProps = function _initialiseProps() {
    var _this = this;

    this._dispatch = function (type, dispatch, actionData, responseData, additionalData, updateData) {
        /*console.log(
          `type, dispatch, actionData, responseData, additionalData, updateData:`,
          type,
          dispatch,
          actionData,
          responseData,
          additionalData,
          updateData
        );*/
        var action = _extends({}, { type: _this.actionNames[type] }, actionData);
        //console.log(`action:`, action);

        // Include response data from async handler if provided
        if (responseData) {
            action.responseData = responseData;
        }

        // Include additional data from async handler if provided
        if (additionalData) {
            action.additionalData = additionalData;
        }

        dispatch(action);

        if (type === 'success' && actionData.options.normalizeResponse) {
            //console.log(`actionData.options:`, actionData.options)
            // DISPATCH RELATED ACTIONS IF WE HAVE normalizationSettings
            if (responseData) {
                if (actionData.normalizationSettings && Array.isArray(actionData.normalizationSettings)) {

                    actionData.normalizationSettings.map(function (entity) {
                        //console.log(`entity:`, entity);
                        if (!(0, _is.isObject)(entity)) {
                            var entityActionResponseData = _this._processResponse(entity, responseData);
                            entityActionResponseData.length && _this._dispatchRelatedAction(entity, type, actionData.instance, entityActionResponseData, dispatch, 'fetch', actionData.options);
                        } else {
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                var _loop = function _loop() {
                                    var _step$value = _slicedToArray(_step.value, 2),
                                        inner_entity = _step$value[0],
                                        inner_entities = _step$value[1];

                                    var entityActionResponseData = _this._processResponse(inner_entity, responseData);
                                    entityActionResponseData.length && _this._dispatchRelatedAction(inner_entity, type, actionData.instance, entityActionResponseData, dispatch, 'fetch', actionData.options);

                                    inner_entities.map(async function (_entity) {
                                        var innerEntityActionResponseData = _this._processResponse(_entity, entityActionResponseData);
                                        innerEntityActionResponseData.length && _this._dispatchRelatedAction(_entity, type, actionData.instance, innerEntityActionResponseData, dispatch, 'fetch', actionData.options);
                                    });
                                };

                                for (var _iterator = Object.entries(entity)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    _loop();
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    });
                }
            }

            if (updateData) {
                if (actionData.normalizationSettings && Array.isArray(actionData.normalizationSettings)) {

                    actionData.normalizationSettings.map(function (entity) {
                        //console.log(`entity:`, entity);
                        if (!(0, _is.isObject)(entity)) {
                            //const entityActionResponseData = this._processResponse(entity, responseData);

                            if (updateData[entity] && updateData[entity].length) {
                                _this._dispatchRelatedAction(entity, type, actionData.instance, updateData[entity], dispatch, 'fetch', actionData.options);
                            }

                            //entityActionResponseData.length && this._dispatchRelatedAction(entity, type, actionData.instance, entityActionResponseData, dispatch);
                        } else {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                var _loop2 = function _loop2() {
                                    var _step2$value = _slicedToArray(_step2.value, 2),
                                        inner_entity = _step2$value[0],
                                        inner_entities = _step2$value[1];

                                    var entityActionResponseData = _this._processResponse(inner_entity, responseData);
                                    entityActionResponseData.length && _this._dispatchRelatedAction(inner_entity, type, actionData.instance, entityActionResponseData, dispatch, 'fetch', actionData.options);

                                    inner_entities.map(async function (_entity) {
                                        var innerEntityActionResponseData = _this._processResponse(_entity, entityActionResponseData);
                                        innerEntityActionResponseData.length && _this._dispatchRelatedAction(_entity, type, actionData.instance, innerEntityActionResponseData, dispatch, 'fetch', actionData.options);
                                    });
                                };

                                for (var _iterator2 = Object.entries(entity)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    _loop2();
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    });
                }
            }
        }

        // Check for additionalData: { deleted: [] }
        /*if(type === 'success' && additionalData.deleted && additionalData.deleted.length){
            console.log(`additionalData:`, additionalData);
            this._dispatchRelatedAction(this.actionNames[type], type, actionData.instance, additionalData.deleted, dispatch, options, 'remove');
        }*/
    };

    this._dispatchRelatedAction = function (entity, type, instance, responseData, dispatch) {
        var actionType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'fetch';
        var options = arguments[6];


        //console.log(`this.config:`, this.config);

        var entityActionData = {
            instance: instance || entity, uidField: 'id', options: {
                appendResponse: options && options.appendResponse !== undefined ? options.appendResponse : true,
                recalcTotal: true
            }
        };
        // Prepare related action
        var entityAction = _extends({}, { type: (0, _actionNames.generateActionNames)(entity.toUpperCase(), actionType)[type] }, entityActionData);
        entityAction.responseData = responseData;
        //console.log(`entityAction:`, entityAction);
        dispatch(entityAction);
    };

    this._processResponse = function (entity, responseData) {
        //console.log(`entity:responseData:`, entity, responseData);
        if (Array.isArray(responseData)) {
            var _entityActionResponseData = responseData.map(function (record) {
                return record[entity];
            });

            var cachedObject = {};
            // "filter" to object - keep original array - garbage be glad too ^^
            //console.log(`entityActionResponseData:`, entityActionResponseData);
            _entityActionResponseData.map(function (item) {
                //console.log(`item:`, item);
                if (Array.isArray(item)) {
                    item.map(function (record) {
                        cachedObject[record.id] = record;
                    });
                } else if (item && item.id) {
                    cachedObject[item.id] = item;
                }
            });
            //console.log(`cachedObject:`, cachedObject);
            // optional, turns object to array
            return Object.values(cachedObject);
        } else {
            return [];
        }
    };

    this.validateInstance = function (instance) {
        if (!instance) throw new Error('clerk.' + _this.config.type + ': Expected instance key');
        if (typeof instance !== "string") throw new Error('clerk.' + _this.config.type + ': Instance key must be a string');
        if (!/^([A-Za-z_0-9]+)$/.test(instance)) throw new Error('clerk.' + _this.config.type + ': Instance key can only contain A-Z, a-z, 0-9 or _');
    };

    this.start = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        //this._dispatch('startPre', ...args)
        _this._dispatch.apply(_this, ["start"].concat(args));
        //this._dispatch('startPost', ...args)
    };

    this.success = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        //this._dispatch('successPre', ...args)
        _this._dispatch.apply(_this, ["success"].concat(args));
        //this._dispatch('successPost', ...args)
    };

    this.error = function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        //this._dispatch('errorPre', ...args)
        _this._dispatch.apply(_this, ["error"].concat(args));
        //this._dispatch('errorPost', ...args)
    };
};

exports.default = BaseAction;